import { render, staticRenderFns } from "./articgolawer.vue?vue&type=template&id=69041df8&scoped=true&"
import script from "./articgolawer.vue?vue&type=script&lang=js&"
export * from "./articgolawer.vue?vue&type=script&lang=js&"
import style0 from "./articgolawer.vue?vue&type=style&index=0&id=69041df8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69041df8",
  null
  
)

export default component.exports